export const NoProjectTranslations = {
  en: {
    noProject: {
      noProjectsTitle: "You haven’t calculated anything yet.",
      noProjectsDescription: "Once you run a performance, it will appear here.",
    },
  },

  es: {
    noProject: {
      noProjectsTitle: "Todavía no has calculado nada.",
      noProjectsDescription: "En cuanto calcules una hoja, aparecerá aquí.",
    },
  },
};
